import React from 'react';

const Error404 = () => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
    <h1 className="text-6xl font-bold mb-4">404</h1>
    <p className="text-xl mb-8">Ranjithkumar says requested page was not found.</p>
    <a href="/" className="px-6 py-3 bg-purple-600 hover:bg-purple-700 rounded-full text-lg font-medium shadow-md transition-transform hover:scale-105">Go Home</a>
  </div>
);

export default Error404;
